import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Create an async thunk for fetching plan templates
export const fetchPlanTemplates = createAsyncThunk('planTemplates/fetchPlanTemplates', async () => {
  const response = await fetch('/api/plans/templates');
  const data = await response.json();
  return data;
});

const planTemplatesSlice = createSlice({
  name: 'planTemplates',
  initialState: { planTemplates: [], status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlanTemplates.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPlanTemplates.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.planTemplates = action.payload;
      })
      .addCase(fetchPlanTemplates.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default planTemplatesSlice.reducer;